import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';

@Component({
  selector: 'app-multiple-check-box-filter',
  standalone: false,
  templateUrl: './multiple-check-box-filter.component.html',
  styleUrl: './multiple-check-box-filter.component.scss',
})
export class MultipleCheckBoxFilterComponent implements OnInit, OnChanges {
  constructor() {}
  allText = 'All';
  ALL = { id: 0, name: this.allText, disabled: false, selected: false };
  isMenuOpen = true;
  isClearActive = false;
  EVENTS = {
    CLEAR: 'clear',
    APPLY: 'apply',
    CHECKBOX_CHANGE: 'checkBoxChange',
  };
  searchQuery = '';
  @Input() displayName: string = 'placeholder';

  @Input() name: string = 'placeholder';
  @Input() options: any = [
    { id: 1, name: 'Option 1', disabled: false, selected: false },
    { id: 2, name: 'Option 2', disabled: false, selected: false },
    { id: 3, name: 'Option 3', disabled: false, selected: false },
    { id: 4, name: 'Option 4', disabled: false, selected: false },
  ];
  @Input() isMandatory = false;
  @Input() menuWidth = 200;
  @Input() enableSearch = true;
  @Input() filterMarginRight = 10;
  @Input() filterMarginBottom = 10;

  @Output() selectionChanged = new EventEmitter<any>();
  selectedOptions = [];
  @ViewChild(MatMenuTrigger, { static: true }) menuTrigger: MatMenuTrigger;
  filteredOptions: any[] = [];
  selectedOptionsStr = '';
  @Input() isSingleSelection = false;
  @Input() optionAllPresent = true;
  @Input() showRadioBtnForSingleSelection = true;
  @Input() mandatorySymbolPosition = 'left';
  @Input() isDisabled = false;
  @Input() autoSelectedOptionWidth = false;
  @ViewChild('inputSearch') inputSearch: any;

  ngOnInit(): void {
    this.options = [...this.options];
    this.filteredOptions = this.options;
  }

  ngOnChanges(changes) {
    if (changes.options) {
      this.options = [...changes.options.currentValue];
      this.filteredOptions = this.options;
      this.selectedOptions = this.removeAll(this.getSelectedOptions());
      const selectionText = this.selectedOptions.join(', ');
      this.selectedOptionsStr = `${selectionText}`;
      this.updateAllOptionState();
    }
    console.log(this.options);
  }

  toggleSelection(option: any) {
    console.log(this.searchQuery);
    if (option.name === this.allText) {
      this.options = this.options.map((opt, ind) => {
        opt.selected = !option.selected;
        return opt;
      });
      this.filteredOptions = this.options.filter((option) => {
        return option.name
          .toLowerCase()
          .includes(this.searchQuery.toLowerCase());
      });
      this.filteredOptions = this.filteredOptions.map((opt, ind) => {
        opt.selected = !option.selected;
        return opt;
      });
      option.selected = !option.selected;
    } else {
      option.selected = !option.selected; // toggle the selection state of the clicked option
      this.updateAllOptionState();
    }
    let response = this.getResponse(this.EVENTS.CHECKBOX_CHANGE);
    this.selectionChanged.emit(response); // emit the updated selection
  }

  singleSelection(option: any) {
    // option.selected = !option.selected; // toggle the selection state of the clicked option
    this.options = this.addFalseToOtherOptions(option);
    let response = this.getResponse(this.EVENTS.CHECKBOX_CHANGE);
    this.selectionChanged.emit(response); // emit the updated selection
    this.applySelections();
  }
  menuClosed() {
    // this.applySelections();
    this.searchQuery = '';
    this.inputSearch.nativeElement.value = '';
    this.filterOptions('');
    console.log('menu closed');
  }
  addFalseToOtherOptions(option) {
    return this.options.map((opt) => {
      // opt.name == option.name ? (opt.selected = true) : (opt.selected = false)
      if (opt.name === option.name) {
        opt.selected = !opt.selected;
      } else {
        opt.selected = false;
      }
      return opt;
    });
  }
  menuOpened() {
    console.log('opened');
  }
  getResponse(event) {
    let response = {
      selectedFilters: this.removeAll(this.getSelectedOptions()),
      name: this.name,
      event,
      isSingleSelection: this.isSingleSelection,
    };
    return response;
  }

  updateAllOptionState() {
    if (this.filteredOptions.length) {
      this.ALL.selected = this.options.every((opt) => opt.selected);
    }
  }

  isSelected(option: any): boolean {
    return option.selected;
  }

  removeAll(arr) {
    return arr.filter((opt) => opt != 'this.allText');
  }

  private getSelectedOptions(): string[] {
    let ans = this.options
      .filter((option) => option.selected)
      .map((option) => option.name);

    console.log(ans);
    return ans;
  }

  filterOptions(value: string) {
    this.searchQuery = value;
    if (value.trim() === '') {
      // if search query is empty, show all options
      this.filteredOptions = this.options;
    } else {
      // otherwise, filter options based on search query
      this.filteredOptions = this.options.filter((option) => {
        return option.name.toLowerCase().includes(value.toLowerCase());
      });
    }
    this.updateAllOptionState();
  }

  clearSearch() {
    this.filteredOptions = [];
  }

  applySelections() {
    this.selectedOptions = this.removeAll(this.getSelectedOptions());
    this.menuTrigger.closeMenu();
    const selectionText = this.selectedOptions.join(', ');
    this.selectedOptionsStr = `${selectionText}`;
    let response = this.getResponse(this.EVENTS.APPLY);

    this.selectionChanged.emit(response);
  }

  clearSelections() {
    this.options.forEach((option) => (option.selected = false));
    let response = this.getResponse(this.EVENTS.CLEAR);
    this.selectionChanged.emit(response);
    this.filteredOptions = this.options;
    this.selectedOptionsStr = '';
    this.selectedOptions = [];
    this.updateAllOptionState();
  }
}
